import script from "./taxesApprovalQuery.vue?vue&type=script&lang=js"
export * from "./taxesApprovalQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__